/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function ResetIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "reset", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M9.50001 15.5L15.5 9.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M9.5 9.5L15.5 15.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M4.56189 13.5C4.52104 13.1724 4.5 12.8387 4.5 12.5C4.5 8.08172 8.08172 4.5 12.5 4.5C16.9183 4.5 20.5 8.08172 20.5 12.5C20.5 16.9183 16.9183 20.5 12.5 20.5C9.75033 20.5 7.32466 19.1128 5.88468 17", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M7 11L4.56189 13.5L2 11", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(ResetIcon);
export default ForwardRef;
//# sourceMappingURL=resetIcon.js.map